import { WasmHandler } from "react-lib/frameworks/WasmController";
import { EncounterInfo } from "./common/EncounterInfo";
import { tidyLocation2 } from "react-lib/apps/common/CUDENT/DentalRecordUtil";

import config from "config/config";
import axios from "axios";

// apis
import ClinicalTermSetView from "issara-sdk/apis/ClinicalTermSetView_core";
import DentalTreatmentIssueList from "issara-sdk/apis/DentalTreatmentIssueList_apps_DEN";
import TreatmentListView from "issara-sdk/apis/TreatmentListView_apps_DEN";
import TreatmentPlanDetailView from "issara-sdk/apis/TreatmentPlanDetailView_apps_DEN";
import TreatmentPlanDetailViewM from "issara-sdk/apis/TreatmentPlanDetailView_apps_DENM";
import TreatmentPlanIssueDetailView from "issara-sdk/apis/TreatmentPlanIssueDetailView_apps_DEN";
import TreatmentPlanIssueListView from "issara-sdk/apis/TreatmentPlanIssueListView_apps_DEN";
import TreatmentPlanList from "issara-sdk/apis/TreatmentPlanList_apps_DEN";
import TreatmentPlanListView from "issara-sdk/apis/TreatmentPlanListView_apps_DEN";
import DentalTreatmentIssueImageList from "issara-sdk/apis/DentalTreatmentIssueImageList_apps_DEN";
import DentalTreatmentIssueImageDetail from "issara-sdk/apis/DentalTreatmentIssueImageDetail_apps_DEN";
import TreatmentPlanSeqView from "issara-sdk/apis/TreatmentPlanSeqView_apps_DEN";
import DoctorList from "issara-sdk/apis/DoctorList_core";
import UserEmployeeDetailAPIView from "issara-sdk/apis/UserEmployeeDetailAPIView_users";

// DPOI
// import { GetDoctorSearch } from "../../DPOI";

// Utils
import { beToAd } from "react-lib/utils/index.js";

// Interface
import { HandleGetEmployeeTokenization } from "react-lib/apps/HISV3/TPD/TPDInterface";

const HOST = `${config.API_HOST}`;
const DENTAL_TISSUE_MAP_PANE: any = {
  baby_tooth: "primary_teeth",
  tooth: "permanent_teeth",
  "Head & Neck": "face",
  "Muscle & TMJ": "muscle",
  Periodontium: "periodontium",
  "Oral cavity": "soft",
  "Jaw-bones": "jaw",
  Odontogram: "odontogram",
};

const TISSUE_MAP_PANE = {
  primary_teeth: "baby_tooth",
  permanent_teeth: "tooth",
  face: "Head & Neck",
  muscle: "Muscle & TMJ",
  periodontium: "Periodontium",
  soft: "Oral cavity",
  jaw: "Jaw-bones",
  odontogram: "Odontogram",
};

export type TreatmentPlanState = {
  id: number;
  treatment: { name: string };
  treatment_issue: [
    {
      id: number;
      product: number;
      product_name: string;
      anesthetics: any[];
      anesthetic_qty: number;
      anesthetic_name: any[];
      quantity: number;
      price_normal: string;
      encounter: number;
      custom_level_price: string | null;
      adjusted_price_level: string | null;
      adjusted_remark: string | null;
      original_price_level: string | null;
      unit_price: string | null;
    }
  ];
  treatment_issue_list: {
    id: number;
    product: number;
    product_name: string;
    anesthetics: any[];
    anesthetic_qty: number;
    anesthetic_name: any[];
    quantity: number;
    price_normal: string;
    encounter: number;
    custom_level_price: string | null;
    adjusted_price_level: string | null;
    adjusted_remark: string | null;
    original_price_level: string | null;
    unit_price: string | null;
  }[];
  division: { name: string };
  doctor: { full_name: string };
  display_seq: number;
  encounter: number;
  exam_encounter: number;
  examination: number;
  examination_location: string;
  examination_principal_diagnosis: string;
  from_continue_treatment_plan: boolean;
  status: string;
  status_label: string;
  estimate_visit: number;
  created: string;
  edited: string;
  edited_th: string;
  edited_thaidate: string;
  edit_user_full_name: string;
  urgency: string;
  urgency_label: string;
  treatment_record: string;
  canceled_reason_name: string;
  canceled_user_full_name: string;
  is_paid: boolean | null;
};

export const TreatmentPlanStateInitial = {
  id: null,
  treatment: { name: "" },
  treatment_issue: [
    {
      id: null,
      product: null,
      product_name: "",
      anesthetics: [],
      anesthetic_qty: 0,
      anesthetic_name: [],
      quantity: 1,
      price_normal: "",
      encounter: null,
      custom_level_price: "",
      adjusted_price_level: "",
      adjusted_remark: "",
      original_price_level: "",
      unit_price: "",
    },
  ],
  treatment_issue_list: [],
  division: { name: "" },
  display_seq: 1,
  doctor: { full_name: "" },
  encounter: null,
  encounter_doctor_full_name: "",
  exam_encounter: null,
  examination: null,
  examination_location: "",
  examination_principal_diagnosis: "",
  from_continue_treatment_plan: false,
  status: "",
  status_label: "",
  estimate_visit: null,
  created: "",
  created_th: "",
  created_user_full_name: "",
  edited: "",
  edited_th: "",
  edited_thaidate: "",
  edit_user_full_name: "",
  started: "",
  urgency: "",
  urgency_label: "",
  treatment_record: "",
  description: "",
  canceled_reason_name: "",
  canceled_user_full_name: "",
};

export const TreatmentPerformStateInitial = {
  id: null,
  treatment: {
    name: "",
  },
  continue_treatment_plan: "",
  treatment_plan: {
    id: null,
    examination: null,
    examination_location: "",
    estimate_visit: 0,
    urgency: "",
    division: null,
    doctor: null,
    description: "",
    status: "",
    previous_status: "",
    previous_division: null,
    previous_doctor: null,
  },
  product: null,
  product_name: "",
  anesthetic_name: [],
  anesthetic_qty: 0,
  anesthetics: [],
  price_normal: "",
  quantity: 1,
  created: "",
  edited: "",
  treatment_record: "",
  encounter: null,
  custom_level_price: "",
  adjusted_price_level: "",
  adjusted_remark: "",
  original_price_level: "",
  unit_price: "",
  is_paid: null,
};

export type TreatmentTodayState = {
  modConfirmTreatmentPlan?: { open?: boolean; token?: string; name?: string; canceled_reason?: number | null; error?: any };
  treatmentTodayMasterData?: any;
  treatmentPlanList?: TreatmentPlanState[];
  treatmentPerformList?: TreatmentPlanState[];
  treatmentIssueImage?: any;

  encounterList?: EncounterInfo[];
  clinicalFindingList?: any[];
  treatmentPlans?: TreatmentPlanState;
  clinicalFindings?: any[];
  encounterInfo?: EncounterInfo;
  patientDetail?: any;
  openModCancelTreatmentPlan?: {
    open: boolean;
    id: any;
    title: string;
    planId: any;
  };
  openModalFilterDentist?: boolean;
  openModalFilterUrgencyLevel?: boolean;
  openModalFilterCurrentLocation?: boolean;
  openModalFilterCurrentPrincipal?: boolean;
  openModalFilterCurrentTp?: boolean;
  openModalFilterCurrentClinic?: boolean;
  openModalFilterCurrentStatus?: boolean;
  openModalFilterCurrentCreated?: boolean;
  openModChangeDisplaySeq?: boolean;

  showButtonSaveSeq?: boolean;

  cloneTreatmentPlanList?: any[];
  dentistFilterListTp?: any[];
  urgencyLevelFilterListTp?: any[];
  currentLocationFilterListTp?: any[];
  currentPrincipalFilterListTp?: any[];
  currentTpFilterListTp?: any[];
  currentClinicFilterListTp?: any[];
  currentStatusFilterListTp?: any[];
  currentCreatedFilterListTp?: any[];

  dentalTreatmentList?: any[];
  isMainLoading?: boolean;
  encounterId?: any;
  clinicalFindingIndex?: number | null;
  openModMessage?: boolean;
  messageTitle?: string;
  errorMessage?: any;
  successMessage?: any;

  // for drawing 59308
  openGallery?: {
    open: boolean;
    activeTabs: string[];
    imageOverlayData: any[];
    hideBabyTooth: boolean;
  };

  // image gallery
  treatmentIssueImageGallery?: {
    open: boolean;
    data: any[];
  };
  currentDoctor?: any;
  django?: any;
};

export const TreatmentTodayStateInitial = {
  modConfirmTreatmentPlan: { open: false, token: null, name: "", canceled_reason: null, error: null },
  treatmentTodayMasterData: {},
  treatmentPlanList: [TreatmentPlanStateInitial],
  treatmentPerformList: [TreatmentPerformStateInitial],

  openModCancelTreatmentPlan: {
    open: false,
    id: null,
    title: "",
    planId: null,
  },
  openModalFilterDentist: false,
  openModalFilterUrgencyLevel: false,
  openModalFilterCurrentLocation: false,
  openModalFilterCurrentPrincipal: false,
  openModalFilterCurrentTp: false,
  openModalFilterCurrentClinic: false,
  openModalFilterCurrentStatus: false,
  openModalFilterCurrentCreated: false,
  openModChangeDisplaySeq: false,

  showButtonSaveSeq: false,

  cloneTreatmentPlanList: [],
  dentistFilterListTp: [],
  urgencyLevelFilterListTp: [],
  currentLocationFilterListTp: [],
  currentPrincipalFilterListTp: [],
  currentTpFilterListTp: [],
  currentClinicFilterListTp: [],
  currentStatusFilterListTp: [],
  currentCreatedFilterListTp: [],

  dentalTreatmentList: [],
};

export type TreatmentTodayEvent =
  | { message: "GetTreatmentTodayMasterData"; params: {} }
  | { message: "refreshCurrentTreatment" }
  | { message: "GetTreatmentSearchList"; params: { search?: string; no_parent: string; abortController?: any; limit?: number; offset?: number } }
  | { message: "GetEmployeeTokenization"; params: { code: string } }
  | { message: "GetTreatmentPlanList"; params: { id: number } }
  | { message: "handleUpdateTreatmentPlanDisplaySeq"; params: {} }
  | { message: "handleUpdateTreatmentPlanSeq" }
  | { message: "handleUpdateTreatmentPlan"; params: {} }
  | { message: "handleCancelTreatmentPlan"; params: {} }
  | { message: "handleDuplicateTreatmentPlan"; params: {} }
  | { message: "handleCompleteTreatmentPlan"; params: {} }
  | { message: "AddTreatmentPlanIssue"; params: {} }
  | { message: "SaveTreatmentPlan"; params: {} }
  | { message: "CancelTreatmentPlan"; params: { id: string; confirm: boolean } }
  | { message: "handleUpdateTreatmentPlanIssue"; params: {} }
  | { message: "SetDentistFilterTp"; params: { filter: any[] } }
  | { message: "SetUrgencyLevelFilterTp"; params: { filter: any[] } }
  | { message: "SetCurrentLocationFilterTp"; params: { filter: any[] } }
  | { message: "SetCurrentPrincipalFilterTp"; params: { filter: any[] } }
  | { message: "SetCurrentTpFilterTp"; params: { filter: any[] } }
  | { message: "SetCurrentClinicFilterTp"; params: { filter: any[] } }
  | { message: "SetCurrentStatusFilterTp"; params: { filter: any[] } }
  | { message: "HandleTreatmentIssueGallery"; params: {} }
  | { message: "HandleTreatmentIssueDrawing"; params: {} }
  | { message: "SetCurrentCreatedFilterTp"; params: { filter: any[] } }
  | { message: "HandleSetSelectTreatmentRecord"; params: {} };

// | { message: "UndoTreatmentPlan"; params: { id: string } };

type Handler = WasmHandler<TreatmentTodayState, TreatmentTodayEvent>;

// GET
export const GetTreatmentTodayMasterData: Handler = async (controller, params) => {
  const [response, error, network] = await ClinicalTermSetView.post({
    apiToken: controller.apiToken,
    params: {},
    data: { question: ["note_cancel_trt_plan"] },
  });
  if (error) {
  } else {
    controller.setState({
      treatmentTodayMasterData: {
        note_cancel_trt_plan: CreateOptions(response.note_cancel_trt_plan?.items || []),
      },
    });
  }
};

export const refreshCurrentTreatment: Handler = async (controller, params) => {
  console.log("refreshCurrentTreatment params: ", params);
  controller.setState({ isMainLoading: true });

  const state = controller.getState();

  let respPlan = [];
  let respPerform = [];
  let filterDentist: any[] = [];
  let filterUrgency: any[] = [];
  let filterLocation: any[] = [];
  let filterPrincipal: any[] = [];
  let filterTp: any[] = [];
  let filterClinic: any[] = [];
  let filterStatus: any[] = [];
  let filterCreated: any[] = [];

  // console.log("refreshCurrentTreatment state.patientDetail?.id: ", state.patientDetail?.id);
  if (state.patientDetail?.id) {
    const paramPlan = { patient: state.patientDetail.id };
    respPlan = await GetTreatmentPlan(controller, paramPlan);
    const tpParams = { list: respPlan, isSelect: true, isFilter: params?.isFilter, useOld: !params?.reset };
    filterDentist = GetArrayUniqueDataTp({ ...tpParams, key: "doctor.full_name", oldList: state.dentistFilterListTp });
    filterUrgency = GetArrayUniqueDataTp({ ...tpParams, key: "urgency_label", oldList: state.urgencyLevelFilterListTp });
    filterLocation = GetArrayUniqueDataTp({
      ...tpParams,
      key: "examination_location",
      oldList: state.currentLocationFilterListTp,
    });
    filterPrincipal = GetArrayUniqueDataTp({
      ...tpParams,
      key: "examination_principal_diagnosis",
      oldList: state.currentPrincipalFilterListTp,
    });
    filterTp = GetArrayUniqueDataTp({ ...tpParams, key: "treatment.name", oldList: state.currentTpFilterListTp });
    filterClinic = GetArrayUniqueDataTp({ ...tpParams, key: "division.name", oldList: state.currentClinicFilterListTp });
    filterStatus = GetArrayUniqueDataTp({ ...tpParams, key: "status_label", oldList: state.currentStatusFilterListTp });
    filterCreated = GetArrayUniqueDataTp({ ...tpParams, key: "created", oldList: state.currentCreatedFilterListTp });
  }

  // console.log("refreshCurrentTreatment state.encounterId: ", state.encounterId);
  if (state.encounterId) {
    // const paramPerform = { encounter: state.encounterId, status: "C" };
    // respPerform = await GetTreatmentPlan(controller, paramPerform);
    if (params.isFetchTreatmentIssue) {
      const paramPerform = { encounter: state.encounterId };

      respPerform = await GetTreatmentIssue(controller, paramPerform);
      // console.log("refreshCurrentTreatment respPerform: ", respPerform);
    }
  }

  let sortingTreatmentPlan: any[] = [];
  if (respPlan?.length > 0) {
    const allUrgencyStatus = ["E", "U"].concat([...new Set([...respPlan]?.filter((f) => !["E", "U"].includes(f.urgency)).map((i) => i.urgency))]);
    for (const urgency of allUrgencyStatus) {
      let treatmentData = [...respPlan].filter((u) => u.urgency === urgency);
      treatmentData = sortingTreatmentPlanData(treatmentData);
      sortingTreatmentPlan = sortingTreatmentPlan.concat(treatmentData);
    }
  }

  let filterTreatmentPlan: any[] = [];

  if (params?.isFilter) {
    const data: any = {
      dentistFilterListTp: filterDentist,
      urgencyLevelFilterListTp: filterUrgency,
      currentLocationFilterListTp: filterLocation,
      currentPrincipalFilterListTp: filterPrincipal,
      currentTpFilterListTp: filterTp,
      currentClinicFilterListTp: filterClinic,
      currentStatusFilterListTp: filterStatus,
      currentCreatedFilterListTp: filterCreated,
    };

    const [searchFilter] = allSearchFilterTp({ allList: sortingTreatmentPlan, data, key: "", value: [] });
    filterTreatmentPlan = searchFilter;
  }

  controller.setState({
    isMainLoading: false,
    treatmentPlanList: params?.isFilter ? filterTreatmentPlan : sortingTreatmentPlan,
    treatmentPerformList: respPerform,
    cloneTreatmentPlanList: [...sortingTreatmentPlan],
    dentistFilterListTp: filterDentist,
    urgencyLevelFilterListTp: filterUrgency,
    currentLocationFilterListTp: filterLocation,
    currentPrincipalFilterListTp: filterPrincipal,
    currentTpFilterListTp: filterTp,
    currentClinicFilterListTp: filterClinic,
    currentStatusFilterListTp: filterStatus,
    currentCreatedFilterListTp: filterCreated,
    ...(params?.reset && {
      openModalFilterDentist: false,
      openModalFilterUrgencyLevel: false,
      openModalFilterCurrentLocation: false,
      openModalFilterCurrentPrincipal: false,
      openModalFilterCurrentTp: false,
      openModalFilterCurrentClinic: false,
      openModalFilterCurrentStatus: false,
      openModalFilterCurrentCreated: false,
    }),
    showButtonSaveSeq: false,
  });
};

export const GetArrayUniqueDataTp = (params: { list: any[]; key: string; isSelect: boolean; oldList?: any[]; useOld?: boolean }) => {
  const { list, key, isSelect } = params;
  const [first, second] = key.split(".");
  const BE_DATE_FORMAT = "YYYY-MM-DD";

  let arrayUniqueByKey: any[] = Array.from(
    new Map(
      list.map((item: any) => {
        let value = item[first];
        if (second) {
          value = value?.[second];
        }
        return [
          value,
          {
            ...item,
            name: value,
            ...(isSelect ? { is_selected: !params.useOld ? [] : params.oldList?.find((acc) => acc.name === value)?.is_selected ?? true } : {}),
          },
        ];
      })
    ).values()
  );
  const sort = arrayUniqueByKey.sort((a, b) => {
    let aValue = a["name"];
    let bValue = b["name"];

    if (first === "created") {
      aValue = beToAd(aValue)?.format(BE_DATE_FORMAT);
      bValue = beToAd(bValue)?.format(BE_DATE_FORMAT);
    }

    return new Intl.Collator().compare(aValue, bValue);
  });

  return sort.filter((item) => item.name);
};

export const SetDentistFilterTp: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, dentistFilter] = searchFilterTp(controller, {
    key: "dentistFilterListTp",
    value: filter,
  });

  controller.setState({
    treatmentPlanList: searchFilter,
    openModalFilterDentist: false,
    dentistFilterListTp: dentistFilter,
  });
};

export const SetUrgencyLevelFilterTp: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, urgenFilter] = searchFilterTp(controller, {
    key: "urgencyLevelFilterListTp",
    value: filter,
  });

  controller.setState({
    treatmentPlanList: searchFilter,
    openModalFilterUrgencyLevel: false,
    urgencyLevelFilterListTp: urgenFilter,
  });
};

export const SetCurrentLocationFilterTp: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, locationFilter] = searchFilterTp(controller, {
    key: "currentLocationFilterListTp",
    value: filter,
  });

  controller.setState({
    treatmentPlanList: searchFilter,
    openModalFilterCurrentLocation: false,
    currentLocationFilterListTp: locationFilter,
  });
};

export const SetCurrentPrincipalFilterTp: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, principalFilter] = searchFilterTp(controller, {
    key: "currentPrincipalFilterListTp",
    value: filter,
  });

  controller.setState({
    treatmentPlanList: searchFilter,
    openModalFilterCurrentPrincipal: false,
    currentPrincipalFilterListTp: principalFilter,
  });
};

export const SetCurrentTpFilterTp: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, tpFilter] = searchFilterTp(controller, {
    key: "currentTpFilterListTp",
    value: filter,
  });

  controller.setState({
    treatmentPlanList: searchFilter,
    openModalFilterCurrentTp: false,
    currentTpFilterListTp: tpFilter,
  });
};

export const SetCurrentClinicFilterTp: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, clinicFilter] = searchFilterTp(controller, {
    key: "currentClinicFilterListTp",
    value: filter,
  });

  controller.setState({
    treatmentPlanList: searchFilter,
    openModalFilterCurrentClinic: false,
    currentClinicFilterListTp: clinicFilter,
  });
};

export const SetCurrentStatusFilterTp: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, statusFilter] = searchFilterTp(controller, {
    key: "currentStatusFilterListTp",
    value: filter,
  });

  controller.setState({
    treatmentPlanList: searchFilter,
    openModalFilterCurrentStatus: false,
    currentStatusFilterListTp: statusFilter,
  });
};

export const SetCurrentCreatedFilterTp: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, statusFilter] = searchFilterTp(controller, {
    key: "currentCreatedFilterListTp",
    value: filter,
  });

  controller.setState({
    treatmentPlanList: searchFilter,
    openModalFilterCurrentCreated: false,
    currentCreatedFilterListTp: statusFilter,
  });
};

const searchFilterTp: Handler = (controller, params) => {
  const { key, value } = params;
  const { cloneTreatmentPlanList } = controller.getState();

  return allSearchFilterTp({ allList: cloneTreatmentPlanList, data: controller.getState(), key, value });
};

const allSearchFilterTp = (params: { allList?: any[]; data: any; key: string; value: any[] }) => {
  const { data, key, value } = params;

  if (key) {
    data[key] = data[key].map((list: any) => {
      return {
        ...list,
        is_selected: value.includes(list.name),
      };
    });
  }

  const compareValue = (data: any, value: string) => {
    if (!data?.[0] || !value) {
      return true;
    }
    return data.find((acc: any) => acc.is_selected && acc.name === value);
  };

  const searchFilter = (params.allList || []).filter((item: any) => {
    return (
      compareValue(data.dentistFilterListTp, item.doctor?.full_name) &&
      compareValue(data.urgencyLevelFilterListTp, item.urgency_label) &&
      compareValue(data.currentLocationFilterListTp, item.examination_location) &&
      compareValue(data.currentPrincipalFilterListTp, item.examination_principal_diagnosis) &&
      compareValue(data.currentTpFilterListTp, item.treatment?.name) &&
      compareValue(data.currentClinicFilterListTp, item.division?.name) &&
      compareValue(data.currentStatusFilterListTp, item.status_label) &&
      compareValue(data.currentCreatedFilterListTp, item.created)
    );
  });

  return [searchFilter, data[key]];
};

export const GetTreatmentPlanList: Handler = async (controller, params) => {
  const [r, e, n] = await TreatmentPlanListView.list({
    apiToken: controller.apiToken,
    exam_id: params.id,
    extra: { headers: { "Accept-Language": "th" } },
  });
  if (e) {
    console.log("Get Treatment Error:", e);
    return;
  }
  let treatmentList = r.items;
  treatmentList?.forEach((item: any, index: number) => {
    if (item.treatment) {
      item["treatment_label"] = item.treatment.name;
      item["treatment"] = item.treatment.id;
    }
    if (item.doctor) {
      item["doctor_full_name"] = item.doctor.full_name;
      item["doctor"] = item.doctor.id;
    }
    if (item.division) {
      item["division_label"] = item.division.name + " (" + item.division.code + ")";
      item["division"] = item.division.id;
    }
    item["planId"] = index + 1;
  });

  controller.setState({
    treatmentPlanList: r.items,
  });
};

export const GetTreatmentSearchList: Handler = async (controller, params) => {
  const abortController = new AbortController();

  // exclude the abortController ref from the params sent to the API
  const { abortController: abortRef, ...listParams } = params;

  if (abortRef) {
    abortRef.current = abortController;
  }

  const [r, e, n] = await TreatmentListView.list({
    apiToken: controller.apiToken,
    params: { ...listParams, limit: 100, offset: 0 },
    extra: { signal: abortController.signal },
  });

  // request was cancelled by a newer search → ignore, keep latest results
  if (abortController.signal.aborted) {
    return;
  }

  if (e) {
    console.log("Get treatment options error", e);
    controller.setState({ dentalTreatmentList: [] });
  } else {
    controller.setState({ dentalTreatmentList: r?.items || [] });
  }
};

export const GetEmployeeTokenization: Handler = async (controller, params) => {
  const state = controller.getState();

  const [response, error, network] = await HandleGetEmployeeTokenization(controller as any, {
    code: params.code,
  });

  if (error) {
    return controller.setState({
      modConfirmTreatmentPlan: { ...state.modConfirmTreatmentPlan, error: error },
    });
  }

  return controller.setState({
    modConfirmTreatmentPlan: { ...state.modConfirmTreatmentPlan, name: decodeURIComponent(atob(response?.token.split(".")[1])) || "", token: response?.token },
  });
};

// CREATE
export const AddTreatmentPlan: Handler = async (controller, params) => {
  const state = controller.getState();

  const findDoctorRes: any[] = [];
  let findDoctorErr = undefined;
  // const [r, e, n] = await DoctorList.list({
  //   apiToken: controller.apiToken,
  //   params: { ...params, limit: 99999 },
  // });
  // if (e) {
  //   console.log("doctor search list error", e);
  //   findDoctorRes = []
  //   findDoctorErr = e
  // } else {
  //   findDoctorRes = r.items
  //   findDoctorErr = e
  // }

  // const [findDoctorRes, findDoctorErr] = await GetDoctorSearch(controller, { search: "ไม่ระบุ แพทย์" });
  let doctor = null;
  let doctor_full_name = "";
  if (findDoctorErr) {
    console.log("new treat add doctor err: ", findDoctorErr);
  } else {
    if (findDoctorRes?.length > 0) {
      doctor = findDoctorRes[0].id;
      doctor_full_name = findDoctorRes[0].full_name;
    }
  }
  const clinicalFinding = state.clinicalFindingList?.[state.clinicalFindingIndex as number];
  let newTreatmentPlan: any = {
    patientId: state.patientDetail.id,
    planId: (state.treatmentPlanList as any)?.length + 1,
    closed: false,
    examination: clinicalFinding.id,
    location: clinicalFinding.location || "",
    treatment: null,
    treatment_label: "",
    doctor: doctor,
    doctor_full_name: doctor_full_name,
    division: null,
    division_label: "",
    description: "",
    status: "P",
    estimate_visit: 1,
    urgency: "R",
    refer_to_clinic: "",
    dentist: "",
  };
  let newTreatmentPlanList: any[] = [].concat(state.treatmentPlanList as any);
  newTreatmentPlanList.push(newTreatmentPlan);
  controller.setState({ treatmentPlanList: newTreatmentPlanList });
};

export const handleDuplicateTreatmentPlan: Handler = async (controller, params) => {
  controller.setState({ isMainLoading: true });

  const state = controller.getState();
  const estimateVisit = params.data.treatment_plan.estimate_visit - 1;

  // #85582 
  // กรณีที่ไม่มีข้อมูล divisionhasuser : ระบบจะต้องดึงข้อมูล Division จาก Encounter นั้นๆ มาใส่ใน Plan แทนการดึงค่าเริ่มต้นเป็นหน่วยเวชระเบียน เพื่อให้การตัดบันทึกค่าใช้จ่ายเข้าสู่ศูนย์ต้นทุนได้อย่างถูกต้อง
  let division = null;
 
  if ( state.selectedDivision !== null)  { 
    // กรณีที่มีข้อมูล divisionhasuser : ระบบยังคงให้ใช้ Division ของผู้ใช้งานตาม
    division = state.selectedDivision?.id; 
  } else {
    // กรณีที่ไม่มีข้อมูล divisionhasuser : ระบบจะต้องดึงข้อมูล Division จาก Encounter นั้นๆ
    division = state.encounterInfo?.division
  }

  const data = {
    exam_id: params.data.treatment_plan.examination,
    treatment: params.data.treatment.id,
    status: params.data.treatment_plan?.previous_status === "R" ? "R" : "I",
    estimate_visit: estimateVisit === 0 ? -1 : estimateVisit,
    urgency: params.data.treatment_plan.urgency,
    division: division,
    // division: params.data.treatment_plan.division || null,
    doctor: state.currentDoctor?.id || null,
    // doctor: params.data.treatment_plan.doctor || null,
    description: params.data.treatment_plan.description,
    original_trt_issue: params.data?.id,
    encounter: state.encounterId,
  };

  const error = await CreateTreatmentPlan(controller, data);

  if (error) {
    controller.setState({ isMainLoading: false, openModMessage: true, messageTitle: "บันทึกไม่สำเร็จ", errorMessage: error });
  } else {
    controller.setState({ isMainLoading: false });

    refreshCurrentTreatment(controller, { isFetchTreatmentIssue: true, reset: true });
  }
};

// UPDATE
const checkDisplaySeq = (currentPlan: any, changePlan: any) => {
  if (changePlan.urgency === "E") {
    if (currentPlan?.urgency === "E") {
      if (
        (["I", "R"].includes(changePlan.status) && ["I", "R"].includes(currentPlan.status)) ||
        (["P", "S"].includes(changePlan.status) && ["P", "S"].includes(currentPlan.status))
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else if (changePlan.urgency === "U") {
    if (["E", "R"].includes(currentPlan?.urgency)) {
      return false;
    } else if (currentPlan.urgency === "U") {
      if (
        (["I", "R"].includes(changePlan.status) && ["I", "R"].includes(currentPlan.status)) ||
        (["P", "S"].includes(changePlan.status) && ["P", "S"].includes(currentPlan.status))
      ) {
        return true;
      } else {
        return false;
      }
    }
  } else if (changePlan.urgency === "R") {
    if (currentPlan?.urgency === "R") {
      if (
        (["I", "R"].includes(changePlan.status) && ["I", "R"].includes(currentPlan.status)) ||
        (["P", "S"].includes(changePlan.status) && ["P", "S"].includes(currentPlan.status))
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  return true;
};

const rearrangeSeqValues = (allPlan: any) => {
  const sortedItems = [...allPlan].sort((a, b) => {
    if (a.display_seq === b.display_seq) {
      // If display_seq values are the same, sort by edited flag
      if (a.isUp) {
        return b.edited - a.edited;
      } else {
        return a.edited - b.edited;
      }
    }
    return a.display_seq - b.display_seq;
  });

  let newSeq = 1;
  const updatedItems = sortedItems.map((item) => {
    const newItem = { ...item, display_seq: newSeq };
    newSeq++;
    return newItem;
  });

  return updatedItems;
};

export const handleUpdateTreatmentPlanDisplaySeq: Handler = (controller, params) => {
  const state = controller.getState();

  let currentPlan: any = state.treatmentPlanList?.filter((item: any) => item.display_seq === parseInt(params.display_seq));

  if (currentPlan?.length === 0) {
    currentPlan = state.treatmentPlanList?.[state.treatmentPlanList?.length - 1];
  }

  const changePlan = state.treatmentPlanList?.filter((item: any) => item.id === params.pk);

  const canChange = checkDisplaySeq(currentPlan?.[0], changePlan?.[0]);

  if (canChange) {
    const allPlanEdit = state.treatmentPlanList?.map((item: any) => {
      if (item.id === params.pk) {
        if (item.display_seq > parseInt(params.display_seq)) {
          return { ...item, display_seq: parseInt(params.display_seq), isUp: true, edited: true };
        } else {
          return { ...item, display_seq: parseInt(params.display_seq), isUp: false, edited: true };
        }
      } else {
        return { ...item, edited: false };
      }
    });

    const result = rearrangeSeqValues(allPlanEdit);
    controller.setState({ treatmentPlanList: result, openModChangeDisplaySeq: false, showButtonSaveSeq: true });
  } else {
    controller.setState({ treatmentPlanList: state.treatmentPlanList, openModChangeDisplaySeq: true });
  }
};

export const handleUpdateTreatmentPlanSeq: Handler = async (controller, params) => {
  controller.setState({ isMainLoading: true });

  const state = controller.getState();

  const [resp, err, netw] = await TreatmentPlanSeqView.put({ apiToken: controller.apiToken, data: { treatmentPlanList: state.treatmentPlanList } });

  if (err) {
    controller.setState({ isMainLoading: false, openModChangeDisplaySeq: true });
  } else {
    controller.setState({ isMainLoading: false, showButtonSaveSeq: false });
    refreshCurrentTreatment(controller, { isFilter: true, isFetchTreatmentIssue: true });
  }
};

export const handleUpdateTreatmentPlan: Handler = async (controller, params) => {
  // const { cloneTreatmentPlanList, treatmentPlanList } = controller.getState();

  let error: any = null;
  // const array = cloneTreatmentPlanList || [];
  // const planList = treatmentPlanList || [];
  // const updateSequence = async (toIndex: number) => {
  //   const currentIndex = array.findIndex((item: any) => item.id === params.pk);
  //   const tpIndex = planList.findIndex((item: any, index: number) => index === toIndex);
  //   const nextIndex = array.findIndex((item: any) => item.id === treatmentPlanList?.[tpIndex]?.id);

  //   // check if urgency is not the same that will not effect to display_seq
  //   if (array[currentIndex]?.urgency !== array[nextIndex]?.urgency) {
  //     return;
  //   }

  //   // check if display_seq is equal
  //   let currentSeq = 0;
  //   let toSeq = 0;
  //   if (true) { //array[currentIndex]?.display_seq === array[currentIndex]?.display_seq) {
  //     currentSeq = nextIndex;
  //     toSeq = currentIndex;
  //   } else {
  //     currentSeq = array[nextIndex].display_seq;
  //     toSeq = array[currentIndex].display_seq;
  //   }

  //   let urlParams = {
  //     exam_id: array[currentIndex].examination,
  //     pk: array[currentIndex].id,
  //     display_seq: currentSeq,
  //   };
  //   const patchCurrent = PatchTreatmentPlan(controller, urlParams);

  //   urlParams = {
  //     exam_id: array[nextIndex].examination,
  //     pk: array[nextIndex].id,
  //     display_seq: toSeq,
  //   };

  //   const patchNext = PatchTreatmentPlan(controller, urlParams);

  //   await Promise.all([patchCurrent, patchNext]);
  // };

  // if (params.type === "top") {
  //   await updateSequence(params.index - 1);
  // } else if (params.type === "down") {
  //   await updateSequence(params.index + 1);
  // } else if (params.type === "drag") {
  //   const toIndex = planList.findIndex((item: any) => item.id === params.toId);
  //   await updateSequence(toIndex);
  // } else
  if (params.type === "delete") {
    const state = controller.getState();
    const [respDel, errDel, netwDel] = await TreatmentPlanDetailViewM.delete({
      apiToken: controller.apiToken,
      ...params,
      data: {
        canceled_reason: state.modConfirmTreatmentPlan?.canceled_reason || params.canceled_reason,
        token: params.token,
        encounter_edited: state.encounterId
      },
    });
    if (errDel) {
      controller.setState({
        isMainLoading: false,
        openModMessage: true,
        messageTitle: "แก้ไขไม่สำเร็จ",
        errorMessage: errDel,
      });
      return;
    }
  } else {
    error = await PatchTreatmentPlan(controller, params);
  }

  if (error) {
    controller.setState({
      isMainLoading: false,
      modConfirmTreatmentPlan: { open: false },
      openModMessage: true,
      messageTitle: "แก้ไขไม่สำเร็จ",
      errorMessage: error,
    });
  } else {
    controller.setState({
      isMainLoading: false,
      modConfirmTreatmentPlan: { open: false, token: "", name: "", canceled_reason: null, error: null },
    });
    refreshCurrentTreatment(controller, { isFilter: true, isFetchTreatmentIssue: true });
  }
};

export const handleCancelTreatmentPlan: Handler = async (controller, params) => {
  const state = controller.getState();

  const [result] = await UserEmployeeDetailAPIView.retrieve({
    apiToken: controller.apiToken,
    pk: controller.cookies.get("user_id"),
  });

  const [response] = await HandleGetEmployeeTokenization(controller as any, {
    code: result?.code,
  });

  const canceledReason = (state.treatmentTodayMasterData?.note_cancel_trt_plan || []).find((option: any) => option.key === 1)?.value;

  handleUpdateTreatmentPlan(controller, { ...params, token: response?.token, canceled_reason: canceledReason });
};

export const AddTreatmentPlanIssue: Handler = async (controller, params) => {
  controller.setState({ isMainLoading: true });

  // const state = controller.getState();
  const planIssueData = { plan: params.planId, encounter: params?.encounterId, quantity: 1 };
  const [response, error, network] = await TreatmentPlanIssueListView.create({
    apiToken: controller.apiToken,
    exam_id: params.examId,
    plan_id: params.planId,
    data: planIssueData,
  });

  if (error) {
    console.error("CreateTreatmentPlanIssue error: ", error);
    controller.setState({
      isMainLoading: false,
      openModMessage: true,
      messageTitle: "บันทึกไม่สำเร็จ",
      errorMessage: "ไม่สามารถเพิ่มได้",
    });
    controller.setState({ isMainLoading: false });
  } else {
    await refreshCurrentTreatment(controller, { isFetchTreatmentIssue: true, reset: true });
    controller.setState({ isMainLoading: false });
  }
};

export const handleCompleteTreatmentPlan: Handler = async (controller, params) => {
  controller.setState({ isMainLoading: true });
  
  const state = controller.getState();
  let promiseArr = [];
  
  let planData: any = { pk: params.data.id, exam_id: params.data.examination, status: "C", encounter_edited: state.encounterId };
  console.log('handleCompleteTreatmentPlan params: ', params);

  // #73439 ให้ CompleteTreatmentPlan ด้วย Division ปัจจุบันเสมอ
  // if (!params.data.division) {

  // #85582 
  // กรณีที่ไม่มีข้อมูล divisionhasuser : ระบบจะต้องดึงข้อมูล Division จาก Encounter นั้นๆ มาใส่ใน Plan แทนการดึงค่าเริ่มต้นเป็นหน่วยเวชระเบียน เพื่อให้การตัดบันทึกค่าใช้จ่ายเข้าสู่ศูนย์ต้นทุนได้อย่างถูกต้อง
  if ( state.selectedDivision !== null )  { 
    // กรณีที่มีข้อมูล divisionhasuser : ระบบยังคงให้ใช้ Division ของผู้ใช้งานตาม
    planData.division = state.selectedDivision?.id;
  } else {
    // กรณีที่ไม่มีข้อมูล divisionhasuser : ระบบจะต้องดึงข้อมูล Division จาก Encounter นั้นๆ
    planData.division = state.encounterInfo?.division?.id
  }

  // }
  if (!params.data.doctor) {
    planData.doctor = state.currentDoctor?.id || null;
    // #planData.doctor = params.data.doctor || null;
  }

  promiseArr.push(PatchTreatmentPlan(controller, planData));

  const planIssueData = { plan_id: params.data.id, plan: params.data.id, exam_id: params.data.examination, encounter: state.encounterId, quantity: 1 };
  promiseArr.push(CreateTreatmentPlanIssue(controller, planIssueData));

  const failResponse = await Promise.all(promiseArr);
  let errorMessage: any = [];
  failResponse.forEach((form) => {
    if (form) {
      errorMessage.push(form);
    }
  });
  if (errorMessage.length > 0) {
    controller.setState({
      isMainLoading: false,
      openModMessage: true,
      messageTitle: "บันทึกไม่สำเร็จ",
      errorMessage: errorMessage,
    });
  } else {
    controller.setState({ isMainLoading: false });
    refreshCurrentTreatment(controller, { isFetchTreatmentIssue: true, reset: true });
  }
};

export const handleUpdateTreatmentPlanIssue: Handler = async (controller, params) => {
  console.log("handleUpdateTreatmentPlanIssue params: ", params);
  controller.setState({ isMainLoading: true });

  if (params.exam_id) {
    let data = params;
    if (params.product) {
      // มีการแก้ไข product ต้อง clear เรื่องราคาออก
      data.adjusted_price_level = null;
      data.custom_level_price = "0.00";
      data.adjusted_remark = "";
    }
    const error = await PatchTreatmentPlanIssue(controller, data);
    console.log("handleUpdateTreatmentPlanIssue params: ", error);
    if (error) {
      controller.setState({ isMainLoading: false, openModMessage: true, messageTitle: "แก้ไขไม่สำเร็จ", errorMessage: error });
    } else {
      controller.setState({ isMainLoading: false });
      refreshCurrentTreatment(controller, { isFetchTreatmentIssue: true });
    }
  } else if (params.inactiveAllIssue) {
    let state = controller.getState();
    let treatmentPerformList: any[] = (state.treatmentPerformList || [])?.filter((i: any) => i.treatment_plan?.id === params.plan_id);

    // treatmentPerformList?.forEach((t: any) => {
    //   await PatchTreatmentPlanIssue(controller, params);
    // })

    let errorList = [];
    for (const treatmentIssue of treatmentPerformList) {
      let error = await PatchTreatmentPlanIssue(controller, {
        pk: treatmentIssue?.id,
        exam_id: treatmentIssue?.treatment_plan?.examination,
        plan_id: params.plan_id,
        active: false,
      });

      // console.log("handleUpdateTreatmentPlanIssue error", error)
      if (error) {
        errorList.push(error);
      }
    }

    if (errorList?.length > 0) {
      controller.setState({ isMainLoading: false, openModMessage: true, messageTitle: "แก้ไขไม่สำเร็จ", errorMessage: errorList?.[0] });
    } else {
      controller.setState({ isMainLoading: false });
      // console.log("handleUpdateTreatmentPlanIssue refresh ")
      refreshCurrentTreatment(controller, { isFetchTreatmentIssue: true });
    }
  }
};

// CANCEL
export const CancelTreatmentPlan: Handler = async (controller, params) => {
  let newTreatmentPlans = [];

  if (!params.confirm) {
    controller.setState({
      openModCancelTreatmentPlan: {
        open: true,
        id: params.id,
        title: params.title,
        planId: params.planId,
      },
    });
    return;
  }
  let state = controller.getState();
  const { id, planId } = state.openModCancelTreatmentPlan;
  // console.log('CancelTreatmentPlan state.clinicalFindingList: ', state.clinicalFindingList);
  // console.log('CancelTreatmentPlan state.clinicalFindingId: ', state.clinicalFindingId);
  // console.log('CancelTreatmentPlan planId: ', planId);
  // console.log('CancelTreatmentPlan id: ', id);
  let setPlanId = 0;
  for (const treatmentPlan of state.treatmentPlanList as any[]) {
    if (treatmentPlan.id === id) {
      // delete from database
      const [r, e, n] = await TreatmentPlanDetailViewM.delete({
        pk: id,
        apiToken: controller.apiToken,
        exam_id: treatmentPlan.examination,
        data: {
          pass_tokenize: true,
          encounter_edited: state.encounterId
        },
      });
      if (e) {
        console.error("CancelTreatmentPlan Delete TreatmentPlan incomplete: ", e);
        return;
      }
    } else {
      if (treatmentPlan.planId !== planId) {
        // delete from list if match planId, do notthing
        newTreatmentPlans.push({ ...treatmentPlan, planId: setPlanId });
        setPlanId = setPlanId + 1;
        console.log("push treatmentPlan.id ", treatmentPlan.id);
      }
    }
  }
  // Mod TreatmentPlan in table (DiagnosisTable)
  let list = [...state.clinicalFindingList];
  let idx = list?.findIndex((item) => item.id === state.clinicalFindingId);

  if (idx !== -1) {
    list[idx].dental_treatment_plan_label = newTreatmentPlans
      .filter((i) => i.status !== "X")
      ?.map((i) => "[" + i?.treatment + "] " + i?.treatment_label)
      ?.join(", ");
  }

  console.log("new treatmentPlanList", newTreatmentPlans);
  controller.setState({
    clinicalFindingList: list,
    treatmentPlanList: newTreatmentPlans,
    openModCancelTreatmentPlan: {
      open: false,
      id: null,
      title: "",
      planId: null,
    },
  });
};

// CREATE OR UPDATE
export const SaveTreatmentPlan: Handler = async (controller, params) => {
  // let state = controller.getState()
  // console.log(state.treatmentPlanList)
  console.log("HandleSaveTreatment:", params);

  let { card, ...data } = params;
  if (params.id) {
    const [r, err, n] = await TreatmentPlanDetailView.update({
      pk: params.id,
      apiToken: controller.apiToken,
      exam_id: params.examination,
      data: {
        ...data,
        encounter_edited: controller.getState().encounterId
      },
    });
    // console.log(" [r, e, n]", [r, err, n]);
    let state = controller.getState();
    if (err) {
      controller.setState({
        errorMessage: {
          ...(state.errorMessage && { ...state.errorMessage }),
          [card]: err,
        },
      });
      console.log("Update Treatment Error:", err);
      return err;
    }
    // else {
    //   // success
    //   controller.setState({
    //     successMessage: {
    //       ...(state.successMessage && { ...state.successMessage }),
    //       [card]: "success",
    //     },
    //   });
    // }
    console.log("update treatment");
  } else {
    data.exam_id = params.examination;
    const error = await CreateTreatmentPlan(controller, data);
    let state = controller.getState();
    if (error) {
      console.log("Create Treatment Error:", error);

      controller.setState({
        errorMessage: {
          ...(state.errorMessage && { ...state.errorMessage }),
          [card]: error,
        },
      });
      return error;
    }
    // else {
    //   // success
    //   controller.setState({
    //     successMessage: {
    //       ...(state.successMessage && { ...state.successMessage }),
    //       [card]: "success",
    //     },
    //   });
    // }
    console.log("create treatment");
  }
};

// -------------------- APIs
// Treatment Plan
const GetTreatmentPlan: Handler = async (controller, params) => {
  const lang = controller.cookies.get("user_lang");

  const [response, error, network] = await TreatmentPlanList.list({
    apiToken: controller.apiToken,
    params: params,
    ...(lang && { extra: { headers: { "Accept-Language": lang } } }),
  });

  if (error) {
    console.log("----- GetTreatmentPlan error : ", error);
    return [];
  } else {
    const URGENCY_STATUS: any = {
      U: 0,
      E: 1,
      R: 2,
    };
    let result: any[] = [];
    // sort by urgency
    response.items = response.items.flat().sort((a: any, b: any) => URGENCY_STATUS[a.urgency] - URGENCY_STATUS[b.urgency]);

    response.items.forEach((resp: any) => {
      const masterOrgan = controller.data?.organ?.items;
      let data: TreatmentPlanState | any = {};
      Object.keys(TreatmentPlanStateInitial).forEach((key) => {
        if (key === "examination_location" && masterOrgan) {
          let locationsSet = resp[key]
            .split(",")
            .map((item: any) => {
              let superTooth = controller.data.organ.items.find((o: any) => o.fullName === item);
              if (superTooth) {
                return superTooth.nickName;
              }
              return item.trim();
            })
            .filter((item: any) => item !== "");

          data[key] = tidyLocation2(locationsSet, controller.data.organ.items).join(",");
        } else {
          data[key] = resp[key];
        }
      });
      result.push(data);
    });
    return result;
  }
};

const CreateTreatmentPlan: Handler = async (controller, data) => {
  const [response, error, network] = await TreatmentPlanListView.create({
    apiToken: controller.apiToken,
    exam_id: data.exam_id,
    data: data,
  });
  if (error) {
    return error;
  } else {
    return false;
  }
};

const PatchTreatmentPlan: Handler = async (controller, data) => {
  const [response, error, network] = await TreatmentPlanDetailView.patch({
    apiToken: controller.apiToken,
    exam_id: data.exam_id,
    pk: data.pk,
    data: {
      ...data,
      encounter_edited: controller.getState().encounterId
    },
  });
  if (error) {
    return error;
  } else {
    return false;
  }
};

// Treatment Plan Issue
export const GetTreatmentIssue: Handler = async (controller, params) => {
  const [response, error, network] = await DentalTreatmentIssueList.list({
    apiToken: controller.apiToken,
    params: params,
  });
  console.log("----- GetTreatmentIssue response: ", response);
  if (error) {
    console.log("----- GetTreatmentIssue error : ", error);
    return [];
  } else {
    let result: any = [];
    response.items.forEach((resp: any) => {
      const masterOrgan = controller.data?.organ?.items;
      let data: TreatmentPerformStateInitial = {};
      Object.keys(TreatmentPerformStateInitial).forEach((key) => {
        if (key === "treatment_plan") {
          Object.keys(TreatmentPerformStateInitial[key]).forEach((child) => {
            if (child === "examination_location" && masterOrgan) {
              let locationsSet = resp[key][child]
                .split(",")
                .map((item: any) => {
                  let superTooth = controller.data.organ.items.find((o: any) => o.fullName === item);
                  if (superTooth) {
                    return superTooth.nickName;
                  }
                  return item.trim();
                })
                .filter((item: any) => item !== "");

              data[key][child] = tidyLocation2(locationsSet, controller.data.organ.items).join(",");
            } else {
              data[key] = { ...data[key], [child]: resp[key][child] };
            }
          });
        } else {
          data[key] = resp[key];
        }
      });
      result.push(data);
    });
    console.log("----- GetTreatmentIssue result : ", result);
    return result;
  }
};

const CreateTreatmentPlanIssue: Handler = async (controller, data) => {
  const [response, error, network] = await TreatmentPlanIssueListView.create({
    apiToken: controller.apiToken,
    exam_id: data.exam_id,
    plan_id: data.plan_id,
    data: data,
  });
  if (error) {
    return error;
  } else {
    return false;
  }
};

const PatchTreatmentPlanIssue: Handler = async (controller, data) => {
  if (data.exam_id && data.plan_id && data.pk) {
    const [response, error, network] = await TreatmentPlanIssueDetailView.patch({
      apiToken: controller.apiToken,
      exam_id: data.exam_id,
      plan_id: data.plan_id,
      pk: data.pk,
      data: data,
    });
    if (error) {
      return error;
    } else {
      return false;
    }
  } else {
    let error: any = {};
    if (!data.exam_id) {
      error["exam_id"] = "This field is required";
    }
    if (!data.plan_id) {
      error["plan_id"] = "This field is required";
    }
    if (!data.pk) {
      error["pk"] = "This field is required";
    }
    return error;
  }
};

export const HandleSetSelectTreatmentRecord: Handler = async (controller, params) => {
  const [treatmentIssueImgDrawing, treatmentIssueImgGallery] = await Promise.all([
    DentalTreatmentIssueImageList.list({
      apiToken: controller.apiToken,
      params: {
        image_type: 2, // OVERLAY
        ...(params?.treatmentPerform?.id && { treatment_issue: params?.treatmentPerform?.id }),
      },
    }),
    DentalTreatmentIssueImageList.list({
      apiToken: controller.apiToken,
      params: {
        image_type: 1, // Gallery
        ...(params?.treatmentPerform?.id && { treatment_issue: params?.treatmentPerform?.id }),
      },
    }),
  ]);

  params?.onCallBack?.({
    ...params.treatmentPerform,
    activeDrawing: treatmentIssueImgDrawing?.[0]?.items?.length > 0,
    activeGallery: treatmentIssueImgGallery?.[0]?.items?.length > 0,
  });
};

export const HandleTreatmentIssueDrawing: Handler = async (controller, params) => {
  if (params?.action === "OPEN_DRAWING") {
    const { patientDetail } = controller.getState();
    const treatmentIssueImg = await DentalTreatmentIssueImageList.list({
      apiToken: controller.apiToken,
      params: {
        image_type: 2, // OVERLAY
        ...(params?.treatment_issue?.id && { treatment_issue: params?.treatment_issue?.id }),
      },
    });

    if (treatmentIssueImg[1]) {
      return console.log("treatmentIssueImg error: ", treatmentIssueImg[1]);
    }

    let activeTabs: any[] = [];
    let treatmentImage: any = {};
    let imageOverlayData: any[] = [];
    let imageSet: any = {};
    if (treatmentIssueImg[0]?.items?.length > 0) {
      activeTabs = treatmentIssueImg[0]?.items
        ?.filter((item: any) => item.tissue_name)
        .reduce((result: any[], item: any) => {
          console.log("item: ", item, result);
          const key = DENTAL_TISSUE_MAP_PANE[item.tissue_name];
          if (key) {
            treatmentImage[key] = { ...item };
            imageOverlayData.push({ ...item });
            imageSet[key] = item.image;
            result.push(key);
          }
          return result;
        }, []);
    } else {
      const organs = controller.data.organ.items;
      const tissue = ["tooth", "face", "muscle", "soft", "jaw", "odontogram"];
      const splitLocation = params?.treatment_issue?.treatment_plan?.examination_location?.split(", ").map((item: any) => item.trim()) || [];
      activeTabs = splitLocation?.reduce((result: any[], item: any) => {
        const find = organs.find((organ: any) => organ.nickName === item);
        if (find) {
          const key = (find.settingKey || find.tissue).replace(/[\d]+/g, "");
          if (tissue.includes(key)) {
            result.push(key);
          }
        }
        return result;
      }, []);
    }
    // imageOverlayData should have any type of tissue that exists in key image
    console.log("imageOverlayData: ", imageOverlayData, activeTabs);
    controller.setState({
      openGallery: {
        open: true,
        activeTabs: activeTabs?.length > 0 ? activeTabs : ["odontogram"],
        imageOverlayData: imageOverlayData.map((item: any) => ({ ...item, image: imageSet })),
        hideBabyTooth: patientDetail?.hideBabyTooth,
      },
      treatmentIssueImage: treatmentImage,
    });
  } else if (params?.action === "CLOSE_DRAWING") {
    controller.setState({
      openGallery: {
        open: false,
        activeTabs: [],
        imageOverlayData: [],
        hideBabyTooth: false,
      },
    });
  } else if (params?.action === "SAVE_DRAWING") {
    const { treatmentIssueImage } = controller.getState();
    //   let examinationData = clinicalFindingList.filter((item) => clinicalFindingId === item.id)[0];

    const tissueImageList = Object.keys(params.data);
    if (tissueImageList.length !== 0) {
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: "Token " + controller.apiToken,
        },
      };
      console.log(tissueImageList);
      for (const list of tissueImageList) {
        const formData = new FormData();
        formData.append("image", params.data[list].image_file);
        formData.append("tissue_name", (TISSUE_MAP_PANE as any)[list]);
        formData.append("treatment_issue", params?.treatment_issue?.id);
        formData.append("image_type", "OVERLAY");
        let res = null;

        if (treatmentIssueImage && treatmentIssueImage?.[list]) {
          if (params.data[list].fully_transparent) {
            formData.append("active", "false");
          } else {
            formData.append("active", "true");
          }

          res = await axios.patch(`${HOST}/apis/DEN/treatment-issue-image/${treatmentIssueImage?.[list]?.id}/`, formData, config);
        } else {
          formData.append("active", "true");
          res = await axios.post(`${HOST}/apis/DEN/treatment-issue-image/`, formData, config);
        }
      }
    }
  }
};

export const HandleTreatmentIssueGallery: Handler = async (controller, params) => {
  const { treatmentIssueImageGallery } = controller.getState();
  if (params?.action === "OPEN_GALLERY") {
    const treatmentIssueImg = await DentalTreatmentIssueImageList.list({
      apiToken: controller.apiToken,
      params: {
        image_type: 1, // GALLERY
        ...(params?.treatment_issue?.id && { treatment_issue: params?.treatment_issue?.id }),
      },
    });

    if (treatmentIssueImg[1]) {
      return console.log("treatmentIssueImg error: ", treatmentIssueImg[1]);
    }

    controller.setState(
      {
        treatmentIssueImageGallery: {
          // ...(treatmentIssueImageGallery as any),
          open: true,
          data: treatmentIssueImg?.[0] || [],
        },
      },
      () => {
        if (params.onNoImage && treatmentIssueImg?.[0]?.items?.length === 0) {
          params.onNoImage?.();
        }
      }
    );
  } else if (params?.action === "CREATE_IMAGE") {
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: "Token " + controller.apiToken,
      },
    };

    const formData = new FormData();
    formData.append("image", params.image);
    formData.append("treatment_issue", params?.treatment_issue?.id);
    formData.append("image_type", "GALLERY");
    formData.append("active", "true");
    const res = await axios.post(`${HOST}/apis/DEN/treatment-issue-image/`, formData, config);
    if (res.data && res.status === 201) {
      await params?.onSuccess?.(res.data);
      await HandleTreatmentIssueGallery(controller, { action: "OPEN_GALLERY", treatment_issue: params?.treatment_issue });
    }
  } else if (params?.action === "UPDATE_IMAGE") {
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: "Token " + controller.apiToken,
      },
    };
    const formData = new FormData();
    formData.append("image", params.imageDataURI);
    formData.append("treatment_issue", params?.treatment_issue?.id);
    formData.append("image_type", "GALLERY");
    formData.append("active", "true");
    formData.append("description", params.detail);
    const res = await axios.patch(`${HOST}/apis/DEN/treatment-issue-image/${params.selectedImage?.id}/`, formData, config);
    await HandleTreatmentIssueGallery(controller, { action: "OPEN_GALLERY", treatment_issue: params?.treatment_issue });
  } else if (params?.action === "DELETE_IMAGE") {
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: "Token " + controller.apiToken,
      },
    };
    const formData = new FormData();
    formData.append("image", params.imageDataURI);
    formData.append("treatment_issue", params?.treatment_issue?.id);
    formData.append("image_type", "GALLERY");
    formData.append("active", "false");
    formData.append("description", params.detail);
    const imageGallery = await axios.patch(`${HOST}/apis/DEN/treatment-issue-image/${params.selectedImage?.id}/`, formData, config);

    await HandleTreatmentIssueGallery(controller, { action: "OPEN_GALLERY", treatment_issue: params?.treatment_issue, onNoImage: params.onNoImage });
  } else if (params?.action === "CLOSE_GALLERY") {
    const { treatmentIssueImageGallery } = controller.getState();
    if (params?.onCallBack && params?.selectedTreatmentPerform?.id) {
      if (treatmentIssueImageGallery?.data?.items?.length > 0) {
        params.onCallBack({ ...params.selectedTreatmentPerform, activeGallery: true });
      } else {
        params.onCallBack({ ...params.selectedTreatmentPerform, activeGallery: false });
      }
    }

    controller.setState({
      treatmentIssueImageGallery: {
        open: false,
        data: [],
        // selectedImage: null
      },
    });
  }
};

const sortingTreatmentPlanData = (data: any[]) => {
  let sortingData = [...data];
  if (sortingData.length > 0) {
    sortingData = [...data].sort((a: any, b: any) => {
      if (a.display_seq > b.display_seq) {
        return 1;
      }
      return -1;
    });
  }
  return sortingData;
};

// -------------------- Utils
const CreateOptions = (items: any[], nameAsId = false, exclude: any[] = []) => {
  let mapOption: any[] = [];
  items.forEach((item, index) => {
    if (exclude.indexOf(item.id) === -1) {
      mapOption.push({
        key: index,
        text: `${item.name || item.name_th || item.name_en || item.value || item.name_code}`,
        value: !nameAsId ? item.id : item.name || item.name_th || item.name_en,
        text_en: item.name_en,
      });
    }
  });
  return mapOption;
};
